import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20anime-style%20illustration%20featuring%20a%20group%20of%20diverse%20manga%20characters%20in%20dynamic%20poses%2C%20warriors%20with%20swords%2C%20magical%20girls%20with%20sparkles%2C%20set%20against%20a%20cosmic%20starry%20backdrop%20with%20vibrant%20orange%20and%20deep%20crimson%20nebula%20clouds%2C%20cinematic%20composition%2C%20intricate%20linework%2C%20warm%20golden%20accents%2C%20epic%20atmosphere%2C%20high%20contrast%20dramatic%20lighting%2C%20Japanese%20manga%20cover%20art%20aesthetic&width=1800&height=900&seq=yy-hero-bg&orientation=landscape"
        alt="yy漫画 - 正版授权漫画平台"
        title="yy漫画 - 正版授权漫画平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-3xl mx-auto">
          正版授权，畅享漫画世界
        </h1>
        <p className="mt-5 text-sm md:text-base text-background-50/80 max-w-xl mx-auto leading-relaxed">
          汇聚热门连载、完结漫画海量资源，涵盖恋爱、热血、悬疑、奇幻等多种类型。每日更新不间断，随时随地畅享优质漫画内容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link
            to="/category/lianai"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/25 rounded-full text-sm font-medium hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-12">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">1000万+</p>
            <p className="text-xs text-background-50/60 mt-1">注册用户</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">20000+</p>
            <p className="text-xs text-background-50/60 mt-1">漫画资源</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">100+</p>
            <p className="text-xs text-background-50/60 mt-1">合作出版社</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">99.7%</p>
            <p className="text-xs text-background-50/60 mt-1">用户好评率</p>
          </div>
        </div>
      </div>
    </section>
  );
}